import { createSlice } from "utils/@reduxjs/toolkit";
import { createAction, PayloadAction } from "@reduxjs/toolkit";
import { Pagination, Query } from "app/containers/types";
import { ContainerState, CustomersState } from "../types";
import { Customer } from "app/containers/Customers/types";

export const logoutSuccess = createAction("LOGOUT_SUCCESS");

// The initial state of the GithubRepoForm container
export const initialState: ContainerState = CustomersState;

const formSlice = createSlice({
  name: "customersSelectState",
  initialState,
  reducers: {
    getCustomers(state, action: PayloadAction<Query>) {
      state.isLoading = true;
    },
    getCustomersSearch(state, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    getCustomersSearchSuccess(state) {
      state.isLoading = false;
    },
    setCustomers(state, action: PayloadAction<{customers: Customer[], pagination: Pagination}>) {
      
      state.pagination = action.payload.pagination;
      if(action.payload.pagination.page == 1) {
        state.customers = action.payload.customers;
      }else{
        state.customers = [...state.customers, ...action.payload.customers];
      }
      state.isLoading = false;
    },
    getCustomersError(state) {
        state.isLoading = false;
    }
  },
});

export const { actions, reducer: customersSelectReducer, name: customersSelectSlice } = formSlice;
